import { create } from 'zustand'

const initialStore = {
  idRichiestaSupporto: null,
  utenteUltimaRichiestaSupporto: null,
}

export const useRichiestaSupportoStore = create(set => ({
  store: { ...initialStore },
  setStore: newStore => set({ store: newStore }),
}))
